import MasterLayout from "../masterLayout/MasterLayout";
// import Breadcrumb from "../components/Breadcrumb";
import ProvisionalActivityLayer from "../components/ProvisionalActivityLayer";

const ProvisionalActivityPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        {/* <Breadcrumb title="Provisional Activity" tooltipContent="Add New Complaint" linkTo="/complains/add"  requiredPermission={{ module: 'complaints', action: 'create' }}/> */}
    
        {/* TableDataLayer */}
        <ProvisionalActivityLayer />

      </MasterLayout>

    </>
  );
};

export default ProvisionalActivityPage; 
